export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.25 },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, amount: 0.25 },
  transition: { duration: 1, ease: "easeOut" },
};

export const stagger = {
  initial: {},
  whileInView: {},
  viewport: { once: true, amount: 0.2 },
  transition: { staggerChildren: 0.12 },
};
